import { useState } from "react";
import { Popover } from "@base-ui/react/popover";
import Button from "../components/ui/button/Button";

export default function NewUser() {
  const [isOpen, setIsOpen] = useState(false);

  async function handleCreateUser() {
    // Implement the logic to create a new user record using the form data
  }

  const handleOpenChange = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Popover.Trigger
        render={
          <Button variant="outline" size="sm">
            New User
          </Button>
        }
        delay={50}
      ></Popover.Trigger>

      <Popover.Portal>
        <Popover.Positioner align="start" sideOffset={8}>
          <Popover.Popup className="box-border rounded-lg bg-[canvas] transition-[scale,opacity] duration-150 data-[starting-style]:scale-90 data-[starting-style]:opacity-0 data-[ending-style]:scale-90 data-[ending-style]:opacity-0 shadow-lg shadow-gray-200 outline-1 outline-gray-200">
            <div className="row-start-2 col-start-1 p-4">
              <form>
                <div className="grid grid-rows-6 grid-cols-1 gap-y-2">
                  <div>
                    <h3>Coming Soon!</h3>
                  </div>

                  <div className="flex items-center justify-end space-x-2">
                    <div>
                      <Button
                        type="submit"
                        size="sm"
                        onClick={handleCreateUser}
                      >
                        Create User
                      </Button>
                    </div>

                    <div>
                      <Button
                        type="button"
                        size="sm"
                        onClick={handleOpenChange}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  );
}
